import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import GlobalConstants from "../../../components/common/global.constants";

const state = {
  language: 'ko',
  env : '',
  ACCESS_TOKEN_KEY : GlobalConstants.ACCESS_TOKEN_DEV ,
  homepageInfo: {

  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js